import React from "react";
import MainLayout from "../../components/Layout/MainLayout";
import { home } from "../../styles/theme";
import Logo from "../../assets/images/sidebar_logo.png";
import QuickLinkTiles from './QuickLinkTiles';
import SARSCard from '../Cards/SARSCard';
import Team from "./Team"; // <-- import it

// import RegisterModal from '../../components/Register/RegisterModal'; // adjust path if needed
import AuthModal from "../../components/AuthModal"; // adjust the path to where your LoginModal is

const HomeContent = () => {
  return (
    <div style={home.wrapper}>

      {/* Hero Section */}
      <div style={home.hero}>
        <img 
          src={Logo} 
          alt="PathoTrack Logo" 
          style={home.heroLogo} 
        />
        <h2 style={home.heroTitle}>
          Pathogen Tracking through Genomic Epidemiology
        </h2>        
        <p style={home.heroText}>
          PathoTrack is a secure web portal designed to enable genomic analysis of high-priority pathogens, 
          including Carbapenem-Resistant Organisms (CROs), <em>Candida auris</em>, and SARS-CoV-2. 
          By integrating pathogen-specific analytical pipelines with a user-friendly web interface, 
          PathoTrack streamlines genomic epidemiology workflows while ensuring efficiency, scalability, and reliability.
        </p>

        {/* <a 
          href="/tutorial" 
          style={home.heroButton}
        >
          Get Started
        </a> */}

        {/* Replace Get Started link with RegisterModal button */}
        <AuthModal defaultMode="register" />
      </div>

      <hr style={home.hr} />

      {/* Quick Link Tiles */}
      <QuickLinkTiles />
      
      <hr style={home.hr} />

      {/* SARS Summary Card */}
      <div>
        <SARSCard />  
      </div>

      <hr style={home.hr} />

      {/* Team Section*/}
      <div>
        <Team />  
      </div>

    </div>
  );
};

const Home = () => (
  <MainLayout>
    <HomeContent />
  </MainLayout>
);

export default Home;